// src/components/BrandLogo.jsx
// شعار النظام (أرباح | Profit) — SVG خفيف بدون صور، يتكيّف مع أي حجم
//
//   <BrandLogo size={64} />                    الرمز فقط
//   <BrandLogo size={40} withName />           الرمز + الاسم
//   <BrandLogo size={40} withName light />     للخلفيات الداكنة
import React, { useId } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function BrandMark({ size = 56, title = "Profit" }) {
  const uid = useId().replace(/:/g, "");
  const bg = `bg-${uid}`, shine = `sh-${uid}`, bar = `br-${uid}`;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={title} style={{ display: "block" }}>
      <defs>
        <linearGradient id={bg} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4F46E5" />
          <stop offset=".55" stopColor="#4338CA" />
          <stop offset="1" stopColor="#0F766E" />
        </linearGradient>
        <radialGradient id={shine} cx=".25" cy=".15" r=".8">
          <stop offset="0" stopColor="#fff" stopOpacity=".35" />
          <stop offset=".6" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={bar} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity=".55" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
      </defs>

      {/* الخلفية */}
      <rect x="2" y="2" width="60" height="60" rx="17" fill={`url(#${bg})`} />
      <rect x="2" y="2" width="60" height="60" rx="17" fill={`url(#${shine})`} />
      <rect x="2.5" y="2.5" width="59" height="59" rx="16.5" fill="none" stroke="#fff" strokeOpacity=".18" />

      {/* أعمدة صاعدة */}
      <rect x="15" y="36" width="8" height="13" rx="2.5" fill={`url(#${bar})`} opacity=".75" />
      <rect x="28" y="28" width="8" height="21" rx="2.5" fill={`url(#${bar})`} opacity=".88" />
      <rect x="41" y="20" width="8" height="29" rx="2.5" fill={`url(#${bar})`} />

      {/* خط النمو + السهم */}
      <path d="M14 31 L27 22 L35 26 L48 14" fill="none" stroke="#34D399" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M41.5 13.2 L48.6 13.4 L48.4 20.5" fill="none" stroke="#34D399" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function BrandLogo({ size = 56, withName = false, light = false, sx }) {
  const { t } = useTranslation();
  const name = t("brand.name", { defaultValue: "أرباح" });
  const tagline = t("brand.tagline", { defaultValue: "نظام إدارة الأعمال" });
  if (!withName) return <Box sx={{ display: "inline-flex", ...sx }}><BrandMark size={size} title={name} /></Box>;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.25, ...sx }}>
      <BrandMark size={size} title={name} />
      <Box sx={{ lineHeight: 1.1 }}>
        <Typography sx={{ fontWeight: 900, fontSize: size * 0.48, color: light ? "#fff" : "#0f172a", letterSpacing: "-.3px", lineHeight: 1.15 }}>
          {name}
        </Typography>
        <Typography sx={{ fontSize: Math.max(11, size * 0.27), fontWeight: 600, color: light ? "rgba(255,255,255,.8)" : "#64748b" }}>
          {tagline}
        </Typography>
      </Box>
    </Box>
  );
}
